import { render, staticRenderFns } from "./HubPagesTable.vue?vue&type=template&id=140e154d&scoped=true&"
import script from "./HubPagesTable.vue?vue&type=script&lang=js&"
export * from "./HubPagesTable.vue?vue&type=script&lang=js&"
import style0 from "./HubPagesTable.vue?vue&type=style&index=0&id=140e154d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140e154d",
  null
  
)

export default component.exports